import Flex from '@Components/Bases/Flex';
import { Typography } from '@mui/material';

type CheckFormProgressProps = {
  progress: boolean;
  language: string;
};

const CheckFormProgress = ({ progress, language }: CheckFormProgressProps) => {
  const backgroundColor = progress ? 'success.main' : 'info.main';

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      position="relative"
      width={20}
      height={20}
      bgcolor={backgroundColor}
      borderRadius="50%"
    >
      <Typography
        fontSize={12}
        sx={{
          position: 'absolute',
          color: 'white',
          fontWeight: 'bold',
        }}
      >
        {language}
      </Typography>
    </Flex>
  );
};

export default CheckFormProgress;
